import { SITE_META } from "@/lib/site";
import ListenTranslateBar from "@/components/ListenTranslateBar";

export default function Privacy() {
  const legalEmail = SITE_META.emails?.legal || "privacy@naturepulse.net";
  const brand = SITE_META.brand;
  const listenText = `SocialPulse Privacy Notice. Your privacy. Effective date July 2026. This notice explains what data ${brand} collects and how we use it. 1. What we collect. Account: email, phone, name, and avatar you provide when signing in via Google, email link, or phone. Observations: photos, notes, timestamps, and any GPS coordinates you attach. Usage: page views, referrers, and IP address for rate-limiting. Retained 30 days. 2. What we don't collect. We don't sell your data. We don't run behavioural advertising. We don't share location traces with third parties. 3. Third parties. Firebase (Google) for authentication only. OpenAI or Gemini for AI stories, translation, and species identification. Images sent for identification are not retained by the provider beyond the request. Resend to send the weekly digest, if you subscribe. 4. Your rights. You may request export or deletion of your data at any time by writing to ${legalEmail}. 5. Cookies. We use a single HttpOnly cookie sp_session to keep you signed in. No tracking cookies.`;
  return (
    <div className="min-h-screen pt-32 pb-20 px-6 md:px-10 max-w-3xl mx-auto text-[color:var(--np-text)]" data-translate-target="true">
      <div className="font-mono-tech text-[10px] tracking-[0.4em] uppercase text-[color:var(--np-brand)] mb-4">
        SocialPulse · Privacy Notice
      </div>
      <h1 className="font-serif-display text-5xl md:text-7xl leading-[0.95] tracking-tighter">Your privacy.</h1>

      <div className="mt-5">
        <ListenTranslateBar text={listenText} testidPrefix="privacy-tools" />
      </div>

      <div className="mt-6 prose max-w-none text-[color:var(--np-text-2)] leading-relaxed space-y-6">
        <p><b>Effective date:</b> July 2026. This notice explains what data {brand} collects and how we use it.</p>

        <h2 className="font-serif-display text-3xl text-[color:var(--np-text)]">1. What we collect</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li><b>Account</b>: email, phone, name, and avatar you provide when signing in (via Google, email link, or phone).</li>
          <li><b>Observations</b>: photos, notes, timestamps, and any GPS coordinates you attach.</li>
          <li><b>Usage</b>: page views, referrers, and IP address for rate-limiting. Retained 30 days.</li>
        </ul>

        <h2 className="font-serif-display text-3xl text-[color:var(--np-text)]">2. What we don't collect</h2>
        <p>We don't sell your data. We don't run behavioural advertising. We don't share location traces with third parties.</p>

        <h2 className="font-serif-display text-3xl text-[color:var(--np-text)]">3. Third parties</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li><b>Firebase</b> (Google) — for authentication only.</li>
          <li><b>OpenAI / Gemini</b> — for AI stories, translation, and species identification. Images sent for identification are not retained by the provider beyond the request.</li>
          <li><b>Resend</b> — to send the weekly digest, if you subscribe.</li>
        </ul>

        <h2 className="font-serif-display text-3xl text-[color:var(--np-text)]">4. Your rights</h2>
        <p data-testid="privacy-legal-email">You may request export or deletion of your data at any time by writing to <a className="underline" href={`mailto:${legalEmail}`}>{legalEmail}</a>.</p>

        <h2 className="font-serif-display text-3xl text-[color:var(--np-text)]">5. Cookies</h2>
        <p>We use a single HttpOnly cookie <code>sp_session</code> to keep you signed in. No tracking cookies.</p>
      </div>
    </div>
  );
}
